/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrSddcMode = 'UNKNOWN_MODE' | 'PROTECT_ONLY' | 'RECOVERY_ONLY' | 'MOUNT_ONLY' | 'ALL';

export const IrrSddcMode = {

    UNKNOWN_MODE: 'UNKNOWN_MODE' as IrrSddcMode,

    PROTECT_ONLY: 'PROTECT_ONLY' as IrrSddcMode,

    RECOVERY_ONLY: 'RECOVERY_ONLY' as IrrSddcMode,

    MOUNT_ONLY: 'MOUNT_ONLY' as IrrSddcMode,

    ALL: 'ALL' as IrrSddcMode
};

